import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AbstractFilter } from '../filter-item/abstract-filter.model';

@Component({
  selector: 'ap-filter-template',
  templateUrl: './filter-template.component.html',
  styleUrls: ['./filter-template.component.css']
})
export class FilterTemplateComponent {

  @Input() filter: AbstractFilter;
  @Output() addFilter = new EventEmitter<AbstractFilter>();

  constructor() { }

  onAddFilter(filter: AbstractFilter) {
    this.addFilter.emit(filter);
  }
}
